function throttle(fn, wait = 300) {
  let throttleTimeoutId = -1, tick = !1;
  return () => {
    clearTimeout(throttleTimeoutId), throttleTimeoutId = setTimeout(fn, wait), tick || (fn.call(), tick = !0, setTimeout(() => {
      tick = !1
    }, wait))
  }
}

if (!customElements.get('sticky-cart')) {
  customElements.define(
    'sticky-cart',
    class StickyCart extends HTMLElement {

      constructor() {
        super();

        this.buttonForm = document.querySelector(`#product-submit-button-${this.dataset.section}`);
        this.throttledOnScroll = throttle(StickyCart.handleScroll.bind(this));
        window.addEventListener('scroll', this.throttledOnScroll);
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.throttledOnScroll)
      }

      static handleScroll() {
        const topOffset = document.querySelector('.shopify-section-group-header-group').offsetHeight;
        this.buttonForm.getBoundingClientRect().bottom < topOffset ? this.classList.add('is-show') : this.classList.remove('is-show');
      }
    }
  );
}
